import {useCallback, useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {getCategories, getDrugInventory, getVendors} from '../Redux/Thunk/drugInventoryActions';

const useInventory = (filters, pagination, loaderchange, popupalert, popuptext) => {
  const [tableData, setTableData] = useState([]);
  const [dataCount, setDataCount] = useState(0);

  const dispatch = useDispatch();

  const allDrugs = useSelector(state => state.drugInventory.drugInventory);
  const categories = useSelector(state => state.drugInventory.categories);
  const vendors = useSelector(state => state.drugInventory.vendors);

  useEffect(() => {
    const fetchListItems = async () => {
      await dispatch(getCategories()).unwrap();
      await dispatch(getVendors()).unwrap();
    };
    fetchListItems();
  }, [dispatch]);

  useEffect(() => {
    setTableData(allDrugs);
  }, [allDrugs]);

  const prevData = useRef(null);

  const fetchData = useCallback(async () => {
    const dataPayload = {
      page: pagination.pageIndex,
      page_size: pagination.pageSize,
      search: filters.search,
      order_date_from: filters.order_date_from || '',
      order_date_to: filters.order_date_to || ''
    };

    if (JSON.stringify(prevData.current) === JSON.stringify(dataPayload)) return; // Avoid duplicate fetches
    prevData.current = dataPayload;

    loaderchange('true');
    try {
      const data = await dispatch(getDrugInventory(dataPayload)).unwrap();
      let drugList = data.data;
      if (drugList.length > 0) {
        setDataCount(data.total_count);
        setTableData(drugList);
      } else {
        popupalert('true');
        setTableData([]);
        setDataCount(0);
        popuptext('No Data Available');
        setTimeout(() => popupalert('false'), 2000);
      }
    } catch (error) {
      console.error('Error fetching patient data:', error);
      popupalert('true');
      popuptext('Failed to fetch data');
      setTimeout(() => popupalert('false'), 2000);
    } finally {
      loaderchange('false');
    }
  }, [filters, pagination]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return {tableData, dataCount, categories, vendors};
};

export default useInventory;
